<template>
  <el-dialog
    title="视频播放"
    :visible.sync="playerVisible"
    width="650px"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    top="5vh"
    :before-close="onClose"
    @open="onOpen()"
  >
    <div id='videoPlayerHjt' v-if="playerVisible" class="cs-videoPlayerHjt"></div>
  </el-dialog>
</template>

<style lang="scss" scoped>
.cs-videoPlayerHjt{
  text-align: center;
}
</style>

<script>
export default {
  name: "videoPplayer",
  data() {
    return {};
  },
  props: {
    playerVisible: false,
    videoData: {
      vid: String, //视频vid 接口数据得到数据
      ts: Number, //时间差
      sign: String //sign参数为secretkey、vid、ts的值按顺序拼凑起来的字符串进行MD5计算得到的结果
    }
    
  },
  mounted() {},
  created() {
    this.init();
  },
  computed: {},
  methods: {
    init() {
      if (!!this.videoData && !!this.videoData.vid) {
        this.$nextTick(() => {
          /**
       播放器代码
      */
          var player = polyvObject("#videoPlayerHjt").videoPlayer({
            'width': '600px',
            'height': '485px',
            vid: this.videoData.vid,
            ts: this.videoData.ts,
            sign: this.videoData.sign
            //vid: "0b5aea312e5a7a0be60049954fd8139f_0",
            //ts: 3021369568437222000,
            //sign: "9e674b7f6a5f63cecbbbd7c52a530bc9"
          });
        });
      }
    },
    onClose() {
      this.$emit("onCloseDialog", false);
    },
    onOpen() {}
  },
  watch: {
    videoData: function() {
      this.init();
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/videoPlayerHjt.vue